import { VERIFICATION_RESULT } from '@/constants/analyst-constants';
import { CustomerInsightResult } from '@/utils/customerInsights';
import palette from '@inscribe/signal/dist/palette';

export const Statuses = {
  WARNING: 'warning',
  ERROR: 'error',
  SUCCESS: 'success',
  LOADING: 'loading',
  DISABLED: 'disabled',
  NOT_APPLICABLE: 'not-applicable',
  FAILED: 'failed',
};
export type StatusType = (typeof Statuses)[keyof typeof Statuses];

export const statusColorMap = (
  state: StatusType,
  colors: string[],
  isHover: boolean = false,
) => {
  switch (state) {
    case Statuses.SUCCESS:
      return isHover
        ? palette[`light-success-${colors[1]}`]
        : palette[`light-success-${colors[0]}`];
    case Statuses.WARNING:
      return isHover
        ? palette[`light-warning-${colors[1]}`]
        : palette[`light-warning-${colors[0]}`];
    case Statuses.ERROR:
      return isHover
        ? palette[`light-error-${colors[1]}`]
        : palette[`light-error-${colors[0]}`];
    default:
      return isHover
        ? palette[`light-neutral-${colors[1]}`]
        : palette[`light-neutral-${colors[0]}`];
  }
};

export const statusBackgroundColour = (
  state: StatusType,
  isHover: boolean = false,
) => {
  return state === Statuses.FAILED
    ? palette['white-base']
    : statusColorMap(state, ['30', '40'], isHover);
};

export const statusIconColor = (state: StatusType) => {
  return state === Statuses.FAILED
    ? palette['light-error-90']
    : statusColorMap(state, ['90']);
};

export const statusTextColour = (state: StatusType) => {
  return statusColorMap(state, ['120']);
};

export const statusIcon = (state: StatusType, size: string = 'small') => {
  switch (state) {
    case Statuses.SUCCESS:
      return size === 'small'
        ? 'small_solid_check'
        : 'medium_solid_check_circle';
    case Statuses.WARNING:
      return size === 'small'
        ? 'small_solid_alert_circle'
        : 'medium_solid_alert_circle';
    case Statuses.ERROR:
      return size === 'small'
        ? 'small_solid_alert_triangle'
        : 'medium_solid_alert_triangle';
    case Statuses.LOADING:
      return undefined;
    case Statuses.NOT_APPLICABLE:
      return size === 'small' ? 'small_solid_info' : 'medium_solid_info_circle';
    case Statuses.DISABLED:
      return 'small_solid_question';
    case Statuses.FAILED:
      return size === 'small'
        ? 'small_solid_alert_triangle'
        : 'medium_solid_alert_triangle';
    default:
      return null;
  }
};

export const mapVerificationResultToIcon = (result: string) => {
  switch (result) {
    case VERIFICATION_RESULT.LOW_RISK:
    case CustomerInsightResult.LOW:
      return 'small-solid-check';
    case VERIFICATION_RESULT.HIGH_RISK:
    case CustomerInsightResult.HIGH:
      return 'small-solid-alert-triangle';
    case VERIFICATION_RESULT.INCONCLUSIVE:
    case CustomerInsightResult.INCONCLUSIVE:
      return 'small-solid-alert-circle';

    case CustomerInsightResult.MEDIUM:
      return 'small-solid-alert-circle';
    default:
      return null;
  }
};

export const mapVerificationResultToStatus = (result: string) => {
  switch (result) {
    case VERIFICATION_RESULT.LOW_RISK:
    case CustomerInsightResult.LOW:
      return Statuses.SUCCESS;
    case VERIFICATION_RESULT.HIGH_RISK:
    case CustomerInsightResult.HIGH:
      return Statuses.ERROR;
    case VERIFICATION_RESULT.INCONCLUSIVE:
    case CustomerInsightResult.INCONCLUSIVE:
      return Statuses.WARNING;
    case CustomerInsightResult.MEDIUM:
      return Statuses.WARNING;
    default:
      return null;
  }
};
